// src/pages/Events.js

import React from 'react';

const Events = () => {
  return (
    <div>
      <div className='main'>
        <div className="column1"></div>
        <div className="column2">

          <div style={{ textAlign: 'center' }}>
            <h1>Events</h1>
          </div>
          <h3>All Events</h3>
          <div style={{ marginBottom: '0.5em' }}>
            Our Events are hosted locally in Sydney, Australia but are accessible through Google Meets on the day.
          </div>
          <h3>Cybernetics, Cyberware and Cyborgs Discussion group</h3>
                    <div style={{ textAlign: 'center', margin: '2em 0' }}>
            <a
              href="https://www.meetup.com/biomedical-engineering-and-cyborgs-group/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                display: 'inline-block',
                background: '#ff9800',
                color: '#fff',
                fontWeight: 'bold',
                padding: '1em 2em',
                borderRadius: '8px',
                textDecoration: 'none',
                boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
                fontSize: '1.2em'
              }}
            >
              Join our Meetup Group!
            </a>
          </div>
          <div style={{ marginBottom: '0.5em' }}>
            <strong>Event:</strong> Cybernetics, Cyberware and Cyborgs meetups discussion group<br />
            <strong>Date:</strong> Every 4th Saturday of the month<br />
            <strong>Time:</strong> 12:00 pm to 1:00 pm AEDT<br />
            <strong>Cost:</strong> Free<br />
            <strong>Address:</strong> Albion Place Hotel, 531 George St, Sydney, 2000, NSW, Australia<br />
            <strong>Online link:</strong> Please advise beforehand by contacting{' '}
            <a href="mailto:support@sabrenetics.com">support@sabrenetics.com</a> or through Meetups link above before joining for us to be notified to start the Google Meet link for remote participants:
            <a href="https://meet.google.com/nwr-gkzd-eju?pli=1" target="_blank" rel="noopener noreferrer">
              https://meet.google.com/nwr-gkzd-eju?pli=1
            </a><br />
            <strong>Audience:</strong> Anyone is welcome from students, to professionals, to hobbyists and more, there's something for everyone. Come join us for food and drinks.<br />
            <strong>About:</strong> We're the Cybernetics, Cyberware, Cyborgs and transhuman discussion group. We aim to gather a community to discuss all things from the convergence of medicine, technology, engineering and philosophy. Our goal is to create scientific discourse in order to empower others along the biomedical engineering journey. We discuss all things biomedical engineering. Come join us as we host, participate and discuss in all things;
          </div>
          <ul>
            <li>Biomedical engineering & healthcare</li>
            <li>Science and Philosophy</li>
            <li>Cyberware, Prosthetics, Brain-Computer interfaces and more</li>
            <li>Cyborgs, Trans/Post-humanism</li>
            <li>Rights, Standards, and Laws</li>
            <li>Commercial and private ventures</li>
            <li>Careers and networking session</li>
            <li>Open source, volunteer, community projects of interest</li>
          </ul>
        </div>
        <div className="column3"></div>
      </div>
    </div>
  );
};

export default Events;
